export const tagTypeAction = {
	create: 4,
	edit: 3,
	delete: 2,
	existing: 1
};

export const tagTypeAPI = {
	4: 'insert',
	3: 'update',
	2: 'delete'
};

export const defaultClientTagColor = 'Gray';

export const colorOptions = [
	{value: 'Red', label: 'Red', className: 'red', chipVariant: 'red'},
	{value: 'Orange', label: 'Orange', className: 'orange', chipVariant: 'orange'},
	{value: 'Teal', label: 'Teal', className: 'teal', chipVariant: 'teal'},
	{value: 'Blue', label: 'Blue', className: 'blue', chipVariant: 'blue'},
	{value: 'Purple', label: 'Purple', className: 'purple', chipVariant: 'purple'},
	{value: 'Green', label: 'Green', className: 'green', chipVariant: 'green'},
	{value: 'Yellow', label: 'Yellow', className: 'yellow', ignore: true},
	{value: 'Gray', label: 'Gray', className: 'gray', ignore: true}
];
